import React from 'react'
export const ShowProducts = (): React.ReactElement => {
    return <div>Product Page</div>
}
